import React from 'react';

import { usePopoverMenu } from '@ad-scripts/presentation/components/common/menu';
import OverflowMenu, {
  OverflowMenuItem,
  OverflowMenuLink,
  OverflowMenuText,
} from 'src/presentation/components/pages/shared/OverflowMenu';

const CampaignRowActions = ({ item, openDeleteModal, root }) => {
  const { onClose, ...overFlowProps } = usePopoverMenu();
  return (
    <OverflowMenu id={item.id} onClose={onClose} {...overFlowProps}>
      <OverflowMenuItem id="recipientCollections">
        <OverflowMenuLink to={`${root}/${item.id}/recipientcollections`}>Edit Recipients</OverflowMenuLink>
      </OverflowMenuItem>
      <OverflowMenuItem id="edit">
        <OverflowMenuLink to={`${root}/${item.id}`}>Edit Campaign</OverflowMenuLink>
      </OverflowMenuItem>
      <OverflowMenuItem
        id="delete"
        onClick={() => {
          onClose();
          openDeleteModal(item.id);
        }}
      >
        <OverflowMenuText>Delete Campaign</OverflowMenuText>
      </OverflowMenuItem>
    </OverflowMenu>
  );
};

export default CampaignRowActions;
